import { CloseModalAction } from "actions/modal/types";
import { ModalBillingPaymentRecordAction } from "./types";
import { ModalBillingPaymentRecord } from "./services";

function stateWithMetaData(state: ModalBillingPaymentRecord): ModalBillingPaymentRecord {
  const canSubmit = Boolean(
    state.get("cardholderName") &&
    state.get("address") &&
    state.get("city") &&
    state.get("country") &&
    state.get("postalCode") &&
    state.get("isCardValid")
  );

  return state.set("canSubmit", canSubmit);
}

export function modalBillingPayment(
  state = new ModalBillingPaymentRecord(),
  action: ModalBillingPaymentRecordAction | CloseModalAction
): ModalBillingPaymentRecord {
  switch (action.type) {
    case "SET_MODAL_BILLING_PAYMENT":
      return stateWithMetaData(
        state.merge(action.payload)
      );

    case "GET_BILLINGS_SUCCESS": {
      const { card } = action.response.data.billing_plan;

      let newState = state;

      if (card) {
        newState = newState.merge({
          cardholderName: card.name,
          address: card.address_line1,
          city: card.address_city,
          country: card.address_country,
          postalCode: card.address_zip,
          newCard: false
        });
      }

      return stateWithMetaData(newState);
    }

    case "POST_CREDIT_REQUEST":
    case "UPDATE_CREDIT_REQUEST":
      return state.set("isLoading", true);
    case "POST_CREDIT_SUCCESS":
    case "UPDATE_CREDIT_SUCCESS":
      return state.merge({
        isLoading: false,
        canSubmit: false,
        isCardValid: false,
        newCard: false
      });
    case "POST_CREDIT_FAILURE":
    case "UPDATE_CREDIT_FAILURE":
      return state.merge({
        isLoading: false,
        canSubmit: false,
        isCardValid: false
      });
    case "CLOSE_MODAL":
      /*
        Need to explicitly clear canSubmit and isCardValid because we cannot
        keep track of credit card info in Redux store
      */
      return state.merge({
        canSubmit: false,
        isCardValid: false
      });
    default:
      return state;
  }
}
